function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import defaultPropTypes from './utils/prop-types';
import { onResize, WDHComponent } from '../../../../../wdh-foundation/wdh';
import mainStore from './stores/main';
import ProgressBar from './views/progress-bar';
import StepManager from './views/step-manager';
import defaultSettings from '../default-settings.json';
var $ = jQuery; // eslint-disable-line

/**
 * @memberOf module:wdh-hearing-test
 */

var WDHHearingTest = /*#__PURE__*/function (_WDHComponent) {
  _inherits(WDHHearingTest, _WDHComponent);

  var _super = _createSuper(WDHHearingTest);

  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHHearingTest() {
    var _this;

    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hearing-test-spot:not(.quiz)';

    _classCallCheck(this, WDHHearingTest);

    _this = _super.call(this, className);
    _this.defaultSettings = defaultSettings;
    return _this;
  }

  _createClass(WDHHearingTest, [{
    key: "init",
    value: function init(component) {
      var settings = Object.assign({}, this.defaultSettings, this.getSettingsFromComponent(component));
      ReactDOM.render( /*#__PURE__*/React.createElement(AppWithObserver, {
        settings: settings
      }), component.querySelector('.component-content'));
    }
    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */

  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[type="application/json"]');
      var settings = {};

      try {
        settings = JSON.parse(settingsElement.textContent);
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }

      return settings;
    }
  }]);

  return WDHHearingTest;
}(WDHComponent);

var DGS = window.DGS; // eslint-disable-line

var App = /*#__PURE__*/function (_React$Component) {
  _inherits(App, _React$Component);

  var _super2 = _createSuper(App);

  function App(props) {
    var _this2;

    _classCallCheck(this, App);

    _this2 = _super2.call(this, props);
    _this2.state = {
      mediaData: [],
      isDesktop: App.isDesktop()
    }; // initialize state with settings

    mainStore.setSteps(props.settings.Steps); // eslint-disable-next-line no-unused-expressions

    props.settings.DefaultPoints && mainStore.setDefaultPoints(props.settings.DefaultPoints);
    return _this2;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Preload all background images
      var mediaData = this.props.settings.Steps.reduce(function (media, step) {
        var backgroundImage = step.BackgroundImage;

        if (backgroundImage && media.indexOf(backgroundImage) === -1) {
          media.push(backgroundImage);
        }

        return media;
      }, []); // eslint-disable-next-line react/no-did-mount-set-state

      this.setState({
        mediaData: mediaData
      });
      onResize(function () {
        _this3.setState({
          isDesktop: App.isDesktop()
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      $(window).on('keydown', this.onHandleKeyboardUse);
    }
  }, {
    key: "onHandleKeyboardUse",
    value: function onHandleKeyboardUse(e) {
      if (e.keyCode === 9) {
        $('.hearing-test-container').eq(0).attr('tabindex', '0').focus().attr('tabindex', '-1');
        $(window).off('keydown', this.onHandleKeyboardUse);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          mediaData = _this$state.mediaData,
          isDesktop = _this$state.isDesktop;
      return /*#__PURE__*/React.createElement("div", {
        className: "hearing-test-container"
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        currentStep: mainStore.currentStepIndex + 1,
        totalSteps: mainStore.steps.length,
        steps: mainStore.steps
      }), /*#__PURE__*/React.createElement(StepManager, {
        settings: this.props.settings,
        isDesktop: isDesktop
      }), /*#__PURE__*/React.createElement("div", {
        className: "preload",
        style: {
          display: 'none'
        }
      }, !!mediaData && mediaData.map(function (media, index) {
        return /*#__PURE__*/React.createElement("img", {
          src: media,
          alt: "",
          key: index
        });
      })));
    }
  }], [{
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }
  }]);

  return App;
}(React.Component);

App.propTypes = {
  settings: defaultPropTypes.settings.isRequired
};
var AppWithObserver = observer(App);
export default WDHHearingTest;